import axios from "axios";

export const getPeakData = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/peak/list?page=1&size=100`,
      {
        auth: {
          username: process.env.REACT_APP_API_KEY_USERNAME,
          password: process.env.REACT_APP_API_KEY_PASSWORD,
        },
      }
    );

    return res.data.items;
  } catch (e) {
    console.log(e);
    return [];
  }
};
